<template>
  <ol class="docs-steps">
    <li>Fill in your details in the generator and click <b>Copy Signature</b>.</li>
    <li>
      Open the signature settings: on Windows <b>File → Options → Mail → Signatures…</b>,
      on Mac <b>Outlook → Preferences → Signatures</b>.
    </li>
    <li>Add a new signature (<b>New</b> on Windows, <b>+</b> on Mac) and name it (e.g. “No. J Signature”).</li>
    <li>
      Click in the editor and paste (<kbd class="docs-kbd">Ctrl V</kbd> / <kbd class="docs-kbd">⌘ V</kbd>).
      Don't add spaces or empty lines after the signature.
    </li>
    <li>
      Set the new signature as default for <b>new messages</b> and for <b>replies/forwards</b>,
      then save.
    </li>
    <li>Click <b>New Email</b> to check the result.</li>
  </ol>
</template>
